export default __webpack_public_path__ + "static/media/star_filled.f4adc490.svg";